import { render, staticRenderFns } from "./investigacion-crear.vue?vue&type=template&id=219b1bc1&scoped=true&"
import script from "./investigacion-crear.vue?vue&type=script&lang=js&"
export * from "./investigacion-crear.vue?vue&type=script&lang=js&"
import style0 from "./investigacion-crear.vue?vue&type=style&index=0&id=219b1bc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b1bc1",
  null
  
)

export default component.exports